var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclusiveContestPopper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4311 29.4967L8.83877 39.9861C8.02336 40.3345 7.20045 39.5108 7.54812 38.6946L18.0284 14.0774C18.301 13.4353 19.1364 13.2736 19.6292 13.7663L33.7388 27.8916C34.2315 28.3843 34.0715 29.2205 33.4286 29.4942H33.4311V29.4967Z",
    fill: "url(#paint0_linear_6598_9589)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7937 28.9011C36.4325 27.2607 34.1406 22.3047 29.6745 17.8342C25.2083 13.3636 20.2593 11.0711 18.6204 12.7114C16.9816 14.3518 19.2735 19.3078 23.7396 23.7783C28.2058 28.2489 33.1548 30.5439 34.7962 28.9011H34.7937Z",
    fill: "url(#paint1_linear_6598_9589)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5309 8.9631C29.898 8.96306 30.5561 8.92171 30.8603 9.07536C31.1034 9.4321 30.4917 11.3258 30.2119 11.7224C30.0996 11.8814 29.5242 11.8561 29.327 11.857C28.979 11.8582 28.1462 11.9118 27.9108 11.7451C27.6709 11.2906 28.2627 9.51037 28.576 9.06735C28.6641 8.94283 29.3575 8.96463 29.5309 8.9631Z",
    fill: "#E52326"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0934 22.4409C34.7019 22.3967 34.8854 22.4199 34.8769 23.1364C34.8712 23.6144 34.9621 24.4096 34.7906 24.8431C34.4338 25.1736 33.3818 25.2366 32.8808 25.2878C32.6321 25.3289 32.4186 25.3802 32.1855 25.2646C31.9174 25.0014 31.9262 23.124 32.1863 22.8434C32.3922 22.6212 33.7584 22.4882 34.0934 22.4409Z",
    fill: "#E52326"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7422 14.6211C36.2142 14.6322 37.4973 14.5928 37.8727 14.6898C38.1089 14.8873 37.7898 15.3701 37.6384 15.5623C37.1285 16.2093 36.8739 16.98 35.928 17.0669C35.5774 17.0729 33.7794 17.0952 33.6714 16.8338C33.718 16.601 33.9019 16.301 34.0519 16.1116C34.5426 15.4922 34.8316 14.6826 35.7422 14.6211Z",
    fill: "#E52326"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4822 7.7401C40.2393 7.66717 40.3477 8.20021 40.4903 8.81661C40.5773 9.19264 40.6483 9.57617 40.7121 9.95721C40.6303 10.0387 40.4649 10.1536 40.367 10.2262C39.7538 10.2727 39.1397 10.3081 38.5252 10.3327C37.5502 10.3865 37.571 9.63165 37.4043 8.8764C37.3354 8.56451 37.3238 8.28628 37.3825 7.97168C37.6153 7.73206 39.0635 7.75729 39.4822 7.7401Z",
    fill: "#E52326"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8639 18.2945C27.2256 18.2909 28.9902 18.4869 29.2355 18.7561C29.4588 19.0011 29.3716 20.7057 29.357 21.1033C29.3511 21.2625 29.2872 21.2855 29.1876 21.3556C28.8518 21.3463 26.9146 21.1229 26.7788 20.8342C26.5574 20.3634 26.6367 19.066 26.6861 18.5152C26.6977 18.3865 26.7729 18.3535 26.8639 18.2945Z",
    fill: "#E52326"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6598_9589",
    x1: 27.7637,
    y1: 17.2574,
    x2: -0.571732,
    y2: 41.2544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDA9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0784191,
    stopColor: "#FDA9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.676633,
    stopColor: "#FFC3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6598_9589",
    x1: 39.609,
    y1: 12.1723,
    x2: 22.3026,
    y2: 23.6359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.527128,
    stopColor: "#FFC3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633141,
    stopColor: "#FFC3F8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclusiveContestPopper);
export default __webpack_public_path__ + "static/media/ExclusiveContestPopper.96f9b12cb6c7ee019df409e68c6c0341.svg";
export { ForwardRef as ReactComponent };